import { createLucideIcon } from 'lucide-react';
export const LockCloseIcon = createLucideIcon('lock', [
  [
    'path',
    {
      d: 'M16.1034 10.7066L19 10.7066V20H5V10.7066H7.5',
      key: '13ephs',
    },
  ],
  [
    'path',
    {
      d: 'M16.1034 10.7066L7.5 10.7066',
      key: '7d4z08',
    },
  ],
  [
    'path',
    {
      d: 'M16.1034 10.7066V7.5C16.1034 5.8912 15 5 14 4.5C13 4 10.7931 3.6259 9.3448 4.511C8.2087 5.2053 7.5 6.5 7.5 7.5C7.5 8.5 7.5 10.7066 7.5 10.7066',
      key: '1i122q',
    },
  ],
]);
